var map = {
	"./Jozef_Ostyn.jpg": "4d44",
	"./ViceGouv_Logo-black.png": "5a31",
	"./coat_of_arms.jpg": "dc66",
	"./flag_fr.svg": "0623",
	"./flag_nl.svg": "299d",
	"./ibz_logo.png": "ad0c",
	"./logo_fr.jpg": "465a",
	"./logo_nl.jpg": "90ca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5dc9";